import { getConfigValue } from 'utils/environment';
import { PaymentISOs } from 'utils/form/constants';

export enum TransactionType {
  PAYMENT = 'payment',
  PREPAID = 'prepaid',
}

interface IgetGooglePaymentsConfigs {
  transactionType: TransactionType;
  countryCode: PaymentISOs;
  overrideMerchantId?: string;
}

/**
 * This function return the Google Pay transaction configs based on the transaction type and countrycode
 * It is returning the gateway and the gateway merchant id
 */
export const getGooglePaymentsConfigs = ({
  transactionType,
  countryCode,
  overrideMerchantId,
}: IgetGooglePaymentsConfigs) => {
  // Checking if it's a prepaid or a payment transaction
  const isPayment = transactionType === TransactionType.PAYMENT;
  // Getting the right gateway based on the transaction type
  const googleConfig = getConfigValue('google');
  const paymentsGateway = googleConfig.paymentsGateway;
  const prepaidPaymentsGateway = googleConfig.prepaidPaymentsGateway;
  const gateway = isPayment ? paymentsGateway : prepaidPaymentsGateway;

  const paymentsMerchantIdMap = googleConfig.paymentsGatewayMerchantId;
  const prepaidPaymentsMerchantIdMap = googleConfig.prepaidPaymentsGatewayMerchantId;

  // Getting the gateway merchant id based on the transaction type and the country code of the transaction
  let gatewayMerchantId;
  switch (countryCode) {
    case PaymentISOs.CA:
      if (isPayment) {
        gatewayMerchantId = paymentsMerchantIdMap.ca;
      } else {
        gatewayMerchantId = prepaidPaymentsMerchantIdMap.ca;
      }
      break;
    case PaymentISOs.CH:
    case PaymentISOs.GB:
    case PaymentISOs.US:
      if (isPayment) {
        gatewayMerchantId = paymentsMerchantIdMap.us;
      } else {
        gatewayMerchantId = prepaidPaymentsMerchantIdMap.us;
      }
      break;
    case PaymentISOs.DE:
      if (isPayment) {
        gatewayMerchantId = overrideMerchantId ?? '';
      } else {
        gatewayMerchantId = '';
      }
      break;
    default:
      gatewayMerchantId = '';
  }

  // Returning the right conf
  return { gateway, gatewayMerchantId };
};
